import React, { useEffect } from "react"
import { AppAntSwitch } from "@components"
import { useReportMultipleModalMultipleEdit } from "Pages/ReportsAlerts/Reports/@hooks"
import { useManualExecution } from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportManualExecutionSwitch() {

	const {
		data,
		setFrequency
	} = useReportMultipleModalMultipleEdit("manuallyExecution")

	useEffect(() => {
		useManualExecution.value = data
	}, [data])
	
	return <AppAntSwitch
		checked={!!data}
		onChange={e => setFrequency(e.target.checked)}
		trueText="Manual Execution"
	/>
}